import type {
  StudyArtifactAttentionReceipt,
  StudyArtifactAttentionAcknowledgmentReason,
  StudyArtifactAttentionListResponse,
} from '@digital-twins/shared-types'
import { httpClient } from './http-client'

/** Per-revision receipts are read and acknowledged at the notification owner. */
export const studyArtifactAttentionApi = {
  async list(threadToken?: string): Promise<StudyArtifactAttentionListResponse> {
    const response = await httpClient.get<StudyArtifactAttentionListResponse>(
      '/notifications/artifact-attention',
      { params: threadToken ? { threadToken } : undefined },
    )
    return response.data
  },

  async acknowledge(
    attentionToken: string,
    reason: StudyArtifactAttentionAcknowledgmentReason,
  ): Promise<StudyArtifactAttentionReceipt> {
    const response = await httpClient.post<StudyArtifactAttentionReceipt>(
      `/notifications/artifact-attention/${encodeURIComponent(attentionToken)}/acknowledge`,
      { reason },
    )
    return response.data
  },
}
